// extracted by mini-css-extract-plugin
export default {"container_inputs":"styles_container_inputs__wMShm","buttons":"styles_buttons__QrF8Q","buttons_actions":"styles_buttons_actions__Fpomt"};